import PropTypes from 'prop-types';
import { Box, Skeleton, Typography } from '@mui/material';
import StatusPill from 'features/IRWorkstation/components/Common/StatusPill';

const QuadPanel = ({
	title,
	badge,
	badgeLabel,
	badgeColor,
	badgeLoading = false,
	subtitle,
	children,
	onScroll,
	scrollableId,
	widgetControls = null,
}) => {
	return (
		<Box
			sx={{
				backgroundColor: 'background.paper',
				border: '0.5px solid',
				borderColor: 'border.light',
				borderRadius: '12px',
				display: 'flex',
				flexDirection: 'column',
				overflow: 'hidden',
				minHeight: 0,
			}}
		>
			{/* header */}
			<Box
				sx={{
					padding: '12px 15px 10px',
					borderBottom: '0.5px solid',
					borderColor: 'border.light',
					flexShrink: 0,
				}}
			>
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						mb: '3px',
					}}
				>
					<Typography
						sx={{
							fontSize: '13px',
							fontWeight: 600,
							color: 'text.primary',
						}}
					>
						{title}
					</Typography>

					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							gap: '6px',
						}}
					>
						{badgeLabel && (
							<Typography
								sx={{
									fontSize: '12px',
									color: 'text.secondary',
								}}
							>
								{badgeLabel}
							</Typography>
						)}

						{badgeLoading ? (
							<Skeleton
								variant='rounded'
								width={100}
								height={20}
								sx={{ borderRadius: '20px' }}
							/>
						) : (
							badge && (
								<StatusPill
									label={badge}
									color={badgeColor}
									sx={{
										fontSize: '11px',
										fontWeight: 500,
										padding: '3px 9px',
										borderRadius: '20px',
									}}
								/>
							)
						)}

						{widgetControls}
					</Box>
				</Box>

				{subtitle && (
					<Box
						sx={{
							fontSize: '11px',
							color: 'text.secondary',
						}}
					>
						{subtitle}
					</Box>
				)}
			</Box>

			{/* scrollable body */}
			<Box
				data-testid='quad-panel-body'
				id={scrollableId}
				sx={{
					flex: 1,
					minHeight: 0,
					overflowY: 'auto',
				}}
				onScroll={onScroll}
			>
				{children}
			</Box>
		</Box>
	);
};

QuadPanel.propTypes = {
	title: PropTypes.string.isRequired,
	badge: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	badgeLabel: PropTypes.string,
	badgeColor: PropTypes.string,
	badgeLoading: PropTypes.bool,
	subtitle: PropTypes.node,
	children: PropTypes.node,
	onScroll: PropTypes.func,
	scrollableId: PropTypes.string,
	widgetControls: PropTypes.node,
};

export default QuadPanel;
